export const createExcerpt =(text)=>{
    if(text.length>120){
        return text.slice(0,100) + "...";
    }
    return text;
}